import React, {useEffect, useState} from 'react'
import {useRequest} from "ahooks";
import {FormSelect} from "../../FormSelect";
import colorService from "../../../../../services/colorService";
import ColorOffCanvas from "./ColorOffCanvas";
import {useFormikContext} from "formik";
import CanvasCreateEditButtons from "../../../UI/Canvas/CanvasCreateEditButtons";
import {toast} from "react-toastify";

const ColorPicker = ({name, onSelected, withCreate}) => {

    const {data, loading, runAsync} = useRequest(colorService.selectable);

    const [currentSelected, setCurrentSelected] = useState(undefined);
    const {values, setFieldValue} = useFormikContext()
    const [isCanvasOpen, setIsCanvasOpen] = useState(false);

    useEffect(() => {
        if (loading)
            return;

        if (values[name]) {
            const option = data.find(d => d.value === values[name])
            option
                ? colorService.fetch(option.uuid).then(res => setCurrentSelected(res))
                : setCurrentSelected(undefined)
        } else {
            setCurrentSelected(undefined)
        }

    }, [data, values[name]])

    const handleResponse = (value) => {
        runAsync().then(() => {
            onSelected({
                value: value.id,
                label: value.name
            })
            setIsCanvasOpen(false)
        })
    }

    const handleDelete = () => {
        colorService.destroy(currentSelected.uuid)
            .then(res => runAsync()
                .then(() => {
                    setFieldValue(name, undefined)
                    toast.success('Operazione eseguita con successo')
                })
            ).catch(err => toast.error(err.response.data.message))
    }

    return (
        <React.Fragment>
            <FormSelect
                name={name}
                onChange={(color) => onSelected(data.find(d => d.value === color))}
                loading={loading}
                placeholder="Seleziona un colore"
                options={data}
                multiple={false}
            />

            {
                withCreate && <>
                    <CanvasCreateEditButtons
                        value={values[name]}
                        canvasOpen={isCanvasOpen}
                        setCanvasOpen={setIsCanvasOpen}
                        handleDelete={handleDelete}
                    />

                    <ColorOffCanvas
                        isOpen={isCanvasOpen}
                        toggle={setIsCanvasOpen}
                        data={currentSelected}
                        handleResponse={handleResponse}
                    />
                </>
            }

        </React.Fragment>
    )
}

export default ColorPicker